import { Loader2 } from "lucide-react";

export function AppLoader() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3">
      <Loader2 className="text-muted-foreground h-6 w-6 animate-spin" />
      <p className="text-muted-foreground text-sm">Loading…</p>
    </div>
  );
}
